module.exports = __webpack_public_path__ + "static/media/whyZoklean_bg.f6331cb5.svg";